import React, { Fragment } from "react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation, Pagination, Autoplay]);
import type { NextPage } from "next";
import Image from "next/image";
import Layout from "../layout/layout";
import banner from "../assets/images/shivsway-banner.jpg";

import styles from "../styles/kishalaya.module.scss";

const shivsway: NextPage = () => {
  return (
    <Layout>
      <div className={styles.csr_banner}>
        <Image src={banner} alt="" width={1920} height={608} />
      </div>
      <section>
        <div className={styles.table}>
          <div className="container">
            <div className="pt-5 w-100">
              <table>
                <tbody>
                  <tr>
                    <td colSpan={2} className={styles.tab_h}>
                      Project-Shivsway
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Our accreditation partner whom SHIVSWAY is affiliated with
                      to run its courses
                    </td>
                    <td className={styles.w_50}>
                      Paschim Banga Society For Skill Development ( PBSSD) which
                      works under the Dept. of Technical Education, Training
                      &amp; Skill Development of W.B
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Functional Areas on which the training is being imparted
                    </td>
                    <td className={styles.w_50}>
                      <ol>
                        <li>CAD – Jewellery Designer</li>
                        <li>Jewellery Retail sales Associate</li>
                      </ol>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Total number of Beneficiaries brought under the training
                      on CAD- Jewellary Designer
                    </td>
                    <td className={styles.w_50}>40</td>
                  </tr>
                  <tr>
                    <td>
                      Total number of Beneficiaries brought under the training
                      on Jewellary Retail Sales Associate
                    </td>
                    <td className={styles.w_50}>40</td>
                  </tr>
                  <tr>
                    <td>
                      Number Of Students Below Poverty Line who have undergone
                      the training with us
                    </td>
                    <td className={styles.w_50}>22</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table className="mt-5 ">
              <tbody>
                <tr>
                  <td>
                    Total Number of students who have successfully completed
                    their paid internship at Senco Gold &amp; Diamond Stores
                    across multiple locations
                  </td>
                  <td className={styles.w_50}>17</td>
                </tr>
                <tr>
                  <td>
                    Total number of students who have got placed in Jewelry
                    Retail Sector
                  </td>
                  <td className={styles.w_50}>13</td>
                </tr>
                <tr>
                  <td>
                    Total number of students who have got placed in Apparel,
                    Fashion &amp; Lifestyle Sector
                  </td>
                  <td className={styles.w_50}>4</td>
                </tr>
                <tr>
                  <td>
                    Total number of students who have got placed in Food &amp;
                    Beverage/ Quick Restaurant Chain
                  </td>
                  <td className={styles.w_50}>7</td>
                </tr>
                <tr>
                  <td>
                    Total number of students who have got placed in Tele-sales
                    &amp; Front Office
                  </td>
                  <td className={styles.w_50}>7</td>
                </tr>
                <tr>
                  <td>
                    Total number of students who have got placed in Footwear
                    Retail
                  </td>
                  <td className={styles.w_50}>1</td>
                </tr>
                <tr>
                  <td>
                    Total number of students who have got placed in
                    Telecommunication &amp; Mobile Network Service
                  </td>
                  <td className={styles.w_50}>5</td>
                </tr>
                <tr>
                  <td>
                    Total number of students placed so far in a full time job
                  </td>
                  <td className={styles.w_50}>37</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default shivsway;
